<template>
  <ul class="divide-y divide-blueGray-300">
     <slot> </slot>
  </ul>
</template>
<script>
export default {

}
</script>
